import CanvasTile from './canvas-tile';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import React from 'react';
import Typography from 'fuse-ui/components/Typography';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ( {
    collectionName: {
        marginBottom: theme.spacing.unit * 2
    }
} );

const CollectionOverview = ( { classes, collection, match } ) => {
    return (
        <>
            <Typography variant="h5" gutterBottom className={classes.collectionName}>{collection.name}</Typography>
            <Grid spacing={16} container>
                {
                    collection.canvases.map( canvas =>
                        ( <CanvasTile
                            key={canvas.id}
                            id={canvas.id}
                            match={match}
                            name={canvas.name}
                        /> )
                    )
                }
            </Grid>
        </>
    );
};

CollectionOverview.propTypes = {
    classes: PropTypes.object.isRequired,
    collection: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
};

export default withStyles( styles )( CollectionOverview );
